import { render } from "./SubSecondManageDashboard.vue?vue&type=template&id=227c83dc"
import script from "./SubSecondManageDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SubSecondManageDashboard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SubSecondStreaming/SubSecondManageDashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "227c83dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('227c83dc', __exports__)) {
    api.reload('227c83dc', __exports__)
  }
  
  module.hot.accept("./SubSecondManageDashboard.vue?vue&type=template&id=227c83dc", () => {
    api.rerender('227c83dc', render)
  })

}


export default __exports__